/**
 * 接口域名的管理
 */
const base = {    
    // url: process.env.NODE_ENV==='production'? 'http://aq.moodlight.com.cn:8080' : 'http://localhost:8080'
    url: process.env.VUE_APP_SERVER_URL
}

export default base;


// WEBPACK FOOTER //
// ./src/api/base.js